import { httpClient } from './http'

export async function getMaps({ apikey }) {
  try {
    const res = await httpClient.get('/v1/maps', {
      params: {
        'page[limit]': 100,
        'page[offset]': 0,
        apikey
      }
    })
    return res.data
  } catch (err) {
    throw new Error(err.response.statusText)
  }
}
